import { Component, Prop, Vue } from 'vue-property-decorator'

import getStyle from '@/helpers/getStyle'

@Component({
	components: {},
})
export default class TableBody extends Vue {
	@Prop() item
	@Prop() field
	@Prop() parent
	@Prop() index
	@Prop() i
	@Prop() pageOffset
	@Prop() onEdit
	@Prop() onDelete

	getStyle = getStyle

	getFieldValue(item, fieldName) {
		let result: any = ''

		result = item[fieldName]

		if (typeof result === 'object') {
			result = result?.name || result
		}

		return result
	}
}
